export default __webpack_public_path__ + "static/media/bg.58b9971c.png";